module.exports = __webpack_public_path__ + "static/img/jp6.324b0eeb.png";